import { createClient } from '@supabase/supabase-js'
import type { Database } from '@jac/shared/generated/db-types'
import { env } from './env'

export const supabase = createClient<Database>(
  env.VITE_PUBLIC_SUPABASE_URL,
  env.VITE_PUBLIC_SUPABASE_ANON_KEY,
  {
    auth: {
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
    },
  },
)

export type SupabaseClient = typeof supabase
